module.exports = __webpack_public_path__ + "static/img/KG.cf60eec6.png";